import { ReactElement } from "react";

export const Injector = ({ children, ...rest }: { children: (props: any) => ReactElement }) => {
  return children(rest);
};
